import { useEffect, Suspense } from "react";
import { lazyWithRetry as lazy } from "@/lib/lazy-with-retry";
import NavBar from "@/components/NavBar";
import Hero from "@/components/Hero";
import ProductInfo from "@/components/ProductInfo";
import BenefitsSection from "@/components/BenefitsSection";
import BenefitsCTA from "@/components/BenefitsCTA";
import PdfLeadMagnet from "@/components/PdfLeadMagnet";
import { useWebSiteSchema, useOrganizationSchema } from "@/components/SEOSchemas";
import { initScrollTracking, initTimeTracking, trackAIReferrer } from "@/utils/analytics";
import SEOHead from "@/components/SEOHead";

// Lazy load below-fold components to reduce initial bundle size and improve TTI
const HowItWorks = lazy(() => import("@/components/HowItWorks"));
const TestimonialsNew = lazy(() => import("@/components/TestimonialsNew"));
const BlogPreviews = lazy(() => import("@/components/BlogPreviews"));
const FAQ = lazy(() => import("@/components/FAQ"));
const CTASection = lazy(() => import("@/components/CTASection"));
const Footer = lazy(() => import("@/components/Footer"));
const FloatingCTABar = lazy(() => import("@/components/FloatingCTABar"));

const Index = () => {
  // Přidání globálních SEO schémat
  useWebSiteSchema();
  useOrganizationSchema();

  // Initialize analytics tracking
  useEffect(() => {
    trackAIReferrer();
    const cleanupScroll = initScrollTracking();
    const cleanupTime = initTimeTracking();

    return () => {
      cleanupScroll?.();
      cleanupTime?.();
    };
  }, []);

  return (
    <main className="min-h-screen">
      <SEOHead
        title="SlimCrystal Review 2026 – Crystal Water Bottle Benefits"
        description="Honest SlimCrystal review: crystal-infused water bottle with 9 natural crystals. Benefits, real user experiences, and where to buy."
        canonical="https://crystalhydrationguide.com/"
        ogImage="https://crystalhydrationguide.com/lovable-uploads/d5cbf445-bc6d-47dd-830c-39fd29f958d5.png"
        productData={{
          name: "SlimCrystal Water Bottle",
          image: "https://crystalhydrationguide.com/lovable-uploads/d5cbf445-bc6d-47dd-830c-39fd29f958d5.png",
          description: "Crystal-infused water bottle featuring 9 types of natural crystals for enhanced hydration and wellness.",
          brand: "SlimCrystal",
          price: "117",
          currency: "USD",
          availability: "https://schema.org/InStock",
          url: "https://crystalhydrationguide.com/"
        }}
      />
      <NavBar />
      <Hero />
      <ProductInfo />
      <BenefitsSection />
      <BenefitsCTA />
      <div className="container mx-auto px-4 py-12 sm:py-16">
        <PdfLeadMagnet />
      </div>
      <Suspense fallback={<div className="min-h-[200px]" />}>
        <HowItWorks />
        <TestimonialsNew />
        <BlogPreviews />
        <FAQ />
        <CTASection />
        <Footer />

        <FloatingCTABar />
      </Suspense>
    </main>
  );
};

export default Index;
